/**
 * Custom Sort Select Web Component
 * Handles custom sort dropdown changes (combined sort-sortOrder values)
 * Works with any form, including facet-filters-form and custom-filters-form
 */
if (!customElements.get('custom-sort-select')) {
  class CustomSortSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.changeHandler = this.handleChange.bind(this);
    }

    connectedCallback() {
      // Find the select element within this component
      this.select = this.querySelector('select[data-custom-sort]');
      
      if (!this.select) return;

      // Attach change listener to this select
      this.select.addEventListener('change', this.changeHandler, true);
      
      // Initial sync from URL on load
      this.syncFromURL();
    }

    disconnectedCallback() {
      if (this.select) {
        this.select.removeEventListener('change', this.changeHandler, true);
      }
    }

    // Update NiceSelect UI for a select element
    updateNiceSelectUI(select) {
      const selectContainer = select.closest('.select');
      if (!selectContainer) return;
      
      const niceList = selectContainer.querySelector('.nice-list');
      if (!niceList) return;
      
      const liElements = niceList.querySelectorAll('li');
      const selectedIndex = select.selectedIndex;
      
      if (liElements[selectedIndex]) {
        liElements[selectedIndex].click();
      }

      selectContainer.querySelector('.nice-select').classList.remove('open');
    }

    // Sync sort dropdown value from URL params
    syncFromURL() {
      if (!this.select) return;

      const urlParams = new URLSearchParams(window.location.search);
      const sortValue = urlParams.get('sort') || '';
      const sortOrderValue = urlParams.get('sortOrder') || 'asc';
      const combinedValue = sortValue && ['alphabetical', 'price', 'date'].includes(sortValue) 
        ? `${sortValue}-${sortOrderValue}` 
        : '';
      
      if (this.select.value !== combinedValue) {
        this.select.value = combinedValue;
        if (typeof window.renderSelects === 'function') {
          window.renderSelects();
        }
        this.updateNiceSelectUI(this.select);
      }
    }

    // Handle custom sort select changes
    handleChange(event) {
      const select = event.target;
      if (select !== this.select || !select.hasAttribute('data-custom-sort')) return;
      
      const sortValue = select.value;
      if (!sortValue || !sortValue.includes('-')) return;
      
      const [sort, sortOrder] = sortValue.split('-');
      if (!['alphabetical', 'price', 'date'].includes(sort) || !['asc', 'desc'].includes(sortOrder)) return;
      
      // Update URL params
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('sort', sort);
      urlParams.set('sortOrder', sortOrder);
      
      const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
      history.pushState({}, '', newUrl);
    }
  }

  customElements.define('custom-sort-select', CustomSortSelect);

  // Add styles to make the web component transparent to layout
  if (!document.getElementById('custom-sort-select-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-sort-select-styles';
    style.textContent = 'custom-sort-select { display: contents; }';
    document.head.appendChild(style);
  }
}
